<template>
    <div class="container-fluid">
        <table class="table table-bordered p-2">
            <thead>
                <th>Dato</th>
                <th>Valor (Dotted Decimal)</th>
                <th>Valor (Binario)</th>
            </thead>
            <tbody>
                <tr>
                    <th>Dirección de Red Inicial</th>
                    <td>{{ initialnetaddress }}</td>
                    <td class="text-monospace">{{ initialnetaddressbin }}</td>
                </tr>
                <tr>
                    <th>Máscara Inicial</th>
                    <td>{{ initialnetmask }} / {{ initialnetmaskcidr }}</td>
                    <td class="text-monospace">{{ initialnetmaskbin }}</td>
                </tr>
                <tr>
                    <th>Número de subredes</th>
                    <td>{{ subnets }}</td>
                    <td>N/A</td>
                </tr>
                <tr>
                    <th>Bits a utilizar</th>
                    <td>{{ newbits }}</td>
                    <td>N/A</td>
                </tr>
                <tr>
                    <th>Máscara nueva</th>
                    <td>{{ newnetmask }} / {{ newnetmaskcidr }}</td>
                    <td class="text-monospace">{{ newnetmaskbin }}</td>
                </tr>
                <tr>
                    <th>Hosts utilizables por subred</th>
                    <td>{{ newhostspernetwork }}</td>
                    <td>N/A</td>
                </tr>
            </tbody>
        </table>
        <table class="table p-2">
            <thead class="thead-light">
                <tr>
                    <th class="text-center" colspan="5">Subredes</th>
                </tr>
                <tr>
                    <th>#</th>
                    <th>D. Red</th>
                    <th>Primera IP</th>
                    <th>Última IP</th>
                    <th>Broadcast</th>
                </tr>
            </thead>
            <tbody v-for="(subnet, subnetno) in newsubnets" :key="subnet.netaddress">
                <tr>
                    <td>{{ subnetno + 1 }}</td>
                    <td>{{ subnet.netaddress }}</td>
                    <td>{{ subnet.firstaddress }}</td>
                    <td>{{ subnet.lastaddress }}</td>
                    <td>{{ subnet.bcastaddress }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

import iputils from "../lib/iputils";

    function isValidCIDR(ipaddr, cidr) {
        if ((cidr < 8) || (cidr > 30)) {
            return false;
        }
        var ipclass = iputils.getClassFromIP(ipaddr);
        var ipbin = iputils.stringToLong(ipaddr);
        var maskbin = iputils.stringToLong(iputils.getCIDRSubnet(ipaddr, cidr).subnetMask);
        var validMask = (ipbin & ~maskbin) == 0;
        if ( ipclass == 'A') {
            return validMask;
        }
        if (ipclass == 'B') {
            return cidr >= 16 && validMask;
        }
        if (ipclass == 'C') {
            return cidr >= 24 && validMask;
        }
        return false;
    }

    function isValidSubnets(cidr, subnets) {
        return (subnets > 0) && (parseInt(cidr) + Math.ceil(Math.log2(subnets))) < 31;
    }

    function areValidProps(na, nc, sn) {
        return iputils.isValidIP(na)
            && isValidCIDR(na, nc)
            && isValidSubnets(nc, sn);
    }

export default {
    props: ["initialnetaddress", "initialnetmaskcidr", "subnets"],
    computed: {
        initialnetaddressbin: function () {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                iputils.stringToBinary(this.initialnetaddress) :
                'N/A';
        },
        initialnetmask: function() {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                iputils.getCIDRSubnet(this.initialnetaddress, this.initialnetmaskcidr).subnetMask :
                'N/A';
        },
        initialnetmaskbin: function() {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                iputils.stringToBinary(this.initialnetmask) :
                'N/A';
        },
        newbits: function() {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                Math.ceil(Math.log2(this.subnets)) :
                'N/A';
        },
        newnetmaskcidr: function() {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                parseInt(this.initialnetmaskcidr) + parseInt(this.newbits) :
                'N/A';
        },
        newnetmask: function() {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                iputils.getCIDRSubnet(this.initialnetaddress, this.newnetmaskcidr).subnetMask :
                'N/A';
        },
        newnetmaskbin: function() {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                iputils.stringToBinary(this.newnetmask) :
                'N/A';
        },
        newhostspernetwork: function() {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                iputils.getCIDRSubnet(this.initialnetaddress, this.newnetmaskcidr).numHosts :
                'N/A';
        },
        newsubnets: function() {
            var retval = [];
            if (!areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) {
                return retval;
            }
            var inal = iputils.stringToLong(this.initialnetaddress);
            var jump = Math.pow(2, 32 - parseInt(this.newnetmaskcidr));
            for (var i = 0; i < this.subnets; i++) {
                var sn = iputils.getCIDRSubnet(iputils.longToString(inal + jump * i), this.newnetmaskcidr);
                retval.push({
                    netaddress: sn.networkAddress,
                    firstaddress: sn.firstAddress,
                    lastaddress: sn.lastAddress,
                    bcastaddress: sn.broadcastAddress
                });
            }
            return retval;
        },

    },
}
</script>